export enum MultiFactorType {
	None,
	OtpCode,
}
